import React from "react";
import {Link} from "react-router-dom";
import {IconButton} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableContainer
    from "@material-ui/core/TableContainer";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import {Edit} from "@material-ui/icons";
import {
    usePagination,
    useRowSelect,
    useTable
} from "react-table";
import PaginationBar from "../../../common/PaginationBar";

export default function EmailTemplateListing(props) {
    const {
        classes,
        CustomLink,
        IndeterminateCheckbox,
        setLoading,
        match,
        disabled,
        getTemplateApi,
    } = props;
    const [actionType, setActionType] = React.useState("");
    const [onInit, setOnInit] = React.useState(true);
    const [totalElements, setTotalElements] = React.useState(0);
    const [data, setData] = React.useState([]);

    const handleSelectChange = (e) => {
        setActionType(e.target.value);
    };
    const columns = React.useMemo(
        () => [
            {
                Header: "ID",
                accessor: "id",
            },
            {
                Header: "Email Type",
                accessor: "emailType",
                Cell: ({row, column, ...rest}) => {
                    return (
                        <Link
                            to={{
                                pathname: match.url.includes("email-template")
                                    ? `${match.url}/${row.original.type}`
                                    : `${match.url}/email-template/${row.original.type}`,
                                state: {disabled},
                            }}
                            style={{
                                textDecoration: "none",
                                color: "#306F9D"
                            }}
                        >
                            {row.original.type}
                        </Link>
                    );
                },
            },
            {
                Header: "Subject Title",
                accessor: "subjectTitle",
                Cell: ({row, column, ...rest}) => {
                    return (
                        <Link
                            to={{
                                pathname: match.url.includes("email-template")
                                    ? `${match.url}/${row.original.type}`
                                    : `${match.url}/email-template/${row.original.type}`,
                                state: {disabled},
                            }}
                            style={{
                                textDecoration: "none",
                                color: "#306F9D"
                            }}
                        >
                            {row.original.subjectEN}
                        </Link>
                    );
                },
            },
            {
                Header: "Create Date",
                accessor: "createDate",
            },
        ],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    const {
        getTableProps,
        headerGroups,
        rows,
        prepareRow,
        setPageSize,
        gotoPage,
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
        state: {pageIndex, pageSize},
    } = useTable(
        {
            columns,
            data,
            initialState: {pageIndex: 0, pageSize: 10},
        },
        usePagination,
        useRowSelect,
        (hooks) => {
            hooks.visibleColumns.push((columns) => [
                // Let's make a column for selection
                {
                    id: "selection",
                    // The header can use the table's getToggleAllRowsSelectedProps method
                    // to render a checkbox
                    Header: ({getToggleAllRowsSelectedProps}) => (
                        <div>
                            <IndeterminateCheckbox
                                {...getToggleAllRowsSelectedProps()}
                                disabled={disabled}
                            />
                        </div>
                    ),
                    // The cell can use the individual row's getToggleRowSelectedProps method
                    // to the render a checkbox
                    Cell: ({row}) => (
                        <div>
                            <IndeterminateCheckbox
                                {...row.getToggleRowSelectedProps()}
                                disabled={disabled}
                            />
                        </div>
                    ),
                },
                ...columns,
                {
                    id: "action",
                    // The header can use the table's getToggleAllRowsSelectedProps method
                    // to render a checkbox
                    Header: () => <div>Action</div>,
                    // The cell can use the individual row's getToggleRowSelectedProps method
                    // to the render a checkbox
                    Cell: ({row}) => (
                        <div
                            style={{display: "inline-flex"}}>
                            <IconButton
                                className={classes.iconBtn}
                                size="small"
                                component={CustomLink}
                                to={{
                                    pathname: match.url.includes("email-template")
                                        ? `${match.url}/${row.original.type}`
                                        : `${match.url}/email-template/${row.original.type}`,
                                    state: {disabled},
                                }}
                            >
                                <Edit fontSize="small"/>
                            </IconButton>
                        </div>
                    ),
                },
            ]);
        }
    );

    const getTemplates = React.useCallback(async () => {
        try {
            setLoading(true);
            const result = await getTemplateApi();
            console.log(result);
            //       setData([result.data]);
            setData(result.data.filter((x) => x));
            if (onInit) {
                setOnInit(false);
                // setTotalElements([result.data].length);
                setTotalElements(result.data.length);
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageIndex, pageSize, setLoading]);

    React.useEffect(() => {
        getTemplates();
    }, [getTemplates]);

    const handleBulkAction = React.useCallback(async () => {
        console.log("dummy");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rows, actionType, getTemplates]);

    return (
        <>
            <Grid
                container
                justify="space-between"
                style={{padding: "10px 25px 10px"}}
            >
                <Grid container item xs={2} md={2}>
                    <Box width="100%" component="span"
                         display="flex">
                        <Box width="100%">
                            <FormControl fullWidth
                                         margin="dense"
                                         variant="outlined">
                                <InputLabel
                                    id="demo-simple-select-outlined-label">
                                    Bulk Actions
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-outlined-label"
                                    id="demo-simple-select-outlined"
                                    value={actionType}
                                    onChange={handleSelectChange}
                                    label="Bulk Actions"
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                        <Box display="flex">
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={handleBulkAction}
                            >
                                Apply
                            </Button>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
            <Grid container xs={12}>
                <TableContainer
                    component={Paper}
                    style={{
                        margin: "0 25px",
                        boxShadow: "none",
                        border: "1px solid #cccccc",
                    }}
                >
                    <fieldset disabled={disabled}
                              className="fieldset">
                        <Table
                            aria-label="simple table"
                            component="ul"
                            style={{margin: "0"}}
                            {...getTableProps()}
                        >
                            <TableHead component="div">
                                {headerGroups.map((headerGroup) => (
                                    <TableRow {...headerGroup.getHeaderGroupProps()}>
                                        {headerGroup.headers.map((column) => (
                                            <TableCell
                                                {...column.getHeaderProps()}
                                                className={`${column.className ?? ""}`}
                                                style={{
                                                    paddingTop: 6,
                                                    paddingBottom: 6,
                                                    lineHeight: "1.1em",
                                                    height: "48px",
                                                }}
                                            >
                                                {column.render("Header")}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))}
                            </TableHead>
                            <TableBody>
                                {rows.map((row, index) => {
                                    prepareRow(row);
                                    return (
                                        <TableRow {...row.getRowProps()}>
                                            {row.cells.map((cell) => {
                                                return (
                                                    <TableCell
                                                        {...cell.getCellProps()}
                                                        className={`${cell.column.className ?? ""}`}
                                                        style={{
                                                            paddingTop: 6,
                                                            paddingBottom: 6,
                                                            lineHeight: "1.1em",
                                                            height: "48px",
                                                        }}
                                                    >
                                                        {cell.render("Cell")}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </fieldset>
                </TableContainer>
            </Grid>
            <Grid
                container
                justify="flex-end"
                style={{
                    paddingRight: "25px",
                    marginTop: "15px"
                }}
            >
                {/* no pagination bar as api has no pagination element */}
            </Grid>
        </>
    );
}
